@layer components {
  .trail {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.125rem;
    margin-block: calc(-1 * var(--space-2));
    padding-inline: var(--space-1);
  }

  .crumb {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    min-inline-size: 0;
    min-block-size: var(--tap-target);
    padding-inline: var(--space-3);
    border-radius: var(--radius-full);
    color: var(--color-on-frame);
    font-size: var(--text-sm);
    font-weight: 620;
    text-decoration: none;
    transition:
      background-color var(--duration-fast) var(--ease-out),
      scale var(--duration-spring) var(--ease-spring);
    -webkit-tap-highlight-color: transparent;

    & svg {
      flex: none;
      inline-size: 1.125rem;
      block-size: 1.125rem;
      stroke-width: 2.1;
    }

    @media (hover: hover) {
      &:hover {
        background: var(--color-frame-pill-hover);
      }
    }

    &:active {
      scale: 0.96;
    }

    &[data-dropping] {
      background: var(--color-action);
      color: var(--color-on-action);
      scale: 1.08;
    }
  }

  .chevron {
    flex: none;
    inline-size: 1rem;
    block-size: 1rem;
    color: var(--color-on-frame-muted);
    opacity: 0.7;
    stroke-width: 2.4;
  }
}
